(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordions"] && !Shopify.designMode) return;
  try {
    const atelierIcons = {
    document: '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M7 4.5h13l5 5V27H7zM20 4.5V10h5M11 14h10M11 18h10M11 22h7"/></svg>',
    delivery: '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M3 9h17v14H3zM20 13h4.5l4 5v5H20zM3 23h3M16 23h6"/><circle cx="10" cy="23.5" r="2.5"/><circle cx="25" cy="23.5" r="2.5"/><path d="M7 5h10"/></svg>',
    return: '<svg viewBox="0 0 32 32" aria-hidden="true"><path d="M4.5 12.5A12 12 0 0 1 26 10M26 10V4.5M26 10h-5.5M27.5 19.5A12 12 0 0 1 6 22M6 22v5.5M6 22h5.5"/><path d="M12 12.5h8v7h-8zM12 15.5h8"/></svg>',
  };

  class BentivanaAtelierAccordions extends HTMLElement {
    #controller = new AbortController();
    #items = [];
    #tabs = [];

    connectedCallback() {
      this.#controller = new AbortController();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.#initialize(), {
          once: true,
          signal: this.#controller.signal,
        });
      } else {
        this.#initialize();
      }
    }

    #initialize() {
      if (!this.isConnected || this.classList.contains('is-enhanced')) return;
      const blocks = [...this.children].filter((child) => child.classList?.contains('accordion-block'));
      this.#items = blocks.map((block) => ({
        block,
        heading: block.querySelector('.accordion__heading-title'),
        content: block.querySelector('.accordion__content'),
        icon: block.dataset.atelierIcon,
      })).filter(({ heading, content }) => heading && content && heading.textContent.trim() && content.textContent.trim());
      if (!this.#items.length) return;

      const tablist = document.createElement('div');
      tablist.className = 'atelier-tabs';
      tablist.setAttribute('role', 'tablist');
      tablist.setAttribute('aria-label', 'Informations produit');

      const panel = document.createElement('div');
      panel.className = 'atelier-panel';
      panel.setAttribute('role', 'tabpanel');
      panel.tabIndex = 0;
      panel.id = `atelier-panel-${this.dataset.atelierId}`;

      this.#items.forEach((item, index) => {
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'atelier-tab';
        tab.id = `atelier-tab-${this.dataset.atelierId}-${index}`;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);
        tab.setAttribute('aria-selected', 'false');
        tab.tabIndex = -1;

        const icon = document.createElement('span');
        icon.className = 'atelier-tab-icon';
        icon.innerHTML = atelierIcons[item.icon] || atelierIcons.document;
        const label = document.createElement('span');
        label.className = 'atelier-tab-label';
        label.innerHTML = item.heading.innerHTML;
        tab.append(icon, label);
        tablist.append(tab);
        this.#tabs.push(tab);

        tab.addEventListener('click', () => this.#select(index), { signal: this.#controller.signal });
        tab.addEventListener('keydown', (event) => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.#tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.#tabs.length) % this.#tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.#tabs.length - 1;
          else return;
          event.preventDefault();
          this.#select(next);
          this.#tabs[next].focus();
        }, { signal: this.#controller.signal });
      });

      this.style.setProperty('--atelier-count', Math.min(this.#items.length, 3));
      this.prepend(tablist, panel);
      this.classList.add('is-enhanced');
      this.#items.forEach(({ block }) => { block.hidden = true; });

      const initiallyOpen = this.#items.findIndex(({ block }) => block.querySelector('accordion-row[open-by-default-on-desktop]'));
      this.#select(initiallyOpen >= 0 ? initiallyOpen : Math.min(1, this.#items.length - 1));

      this.addEventListener('shopify:block:select', (event) => {
        const index = this.#items.findIndex(({ block }) => block === event.target || block.contains(event.target));
        if (index >= 0) this.#select(index);
      }, { signal: this.#controller.signal });
    }

    disconnectedCallback() {
      this.#controller.abort();
      this.querySelector(':scope > .atelier-tabs')?.remove();
      this.querySelector(':scope > .atelier-panel')?.remove();
      this.#items.forEach(({ block }) => { block.hidden = false; });
      this.#items = [];
      this.#tabs = [];
      this.classList.remove('is-enhanced');
    }

    #select(index) {
      const panel = this.querySelector(':scope > .atelier-panel');
      if (!panel || !this.#items[index]) return;
      this.#tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      panel.setAttribute('aria-labelledby', this.#tabs[index].id);
      panel.replaceChildren(this.#items[index].content.cloneNode(true));
    }
  }

  if (!customElements.get('bentivana-atelier-accordions')) {
    customElements.define('bentivana-atelier-accordions', BentivanaAtelierAccordions);
  }
  } catch(e) { console.error(e); }
})();

})();
